import * as angular from 'angular';
import nvSupportsModule from '../_module';
import { SupportsTableCtrl } from './supports-table.controller';

export const SupportsTableComponent = {
  controller: SupportsTableCtrl,
  template: require('./supports-table.html'),
  bindings: {
    currentSchool: '<',
    currentUser: '<',
    onSupportUpdate: '&',
    schoolSupports: '<',
    studentSupports$: '<',
  },
};

angular.module(nvSupportsModule).component('supportsTable', SupportsTableComponent);
